export default "__VITE_ASSET__3v4iQ3FT__"